import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import gql from 'graphql-tag';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { cliente_proveedor } from 'src/app/shared/object/cliente_proveedor.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import * as _ from 'lodash';
import { ClienteProveedorService } from 'src/app/services/cliente-proveedor.service';
import { debounceTime, filter } from 'rxjs/operators';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-clientes-form-datos-personales',
  templateUrl: './form-datos-personales.component.html',
  styleUrls: ['../clientes.component.scss'],
  providers: [SecurityService, ValidadoresService],
})
export class FormDatosPersonalesComponent implements OnInit {
  // Outputs
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>();
  @Output() onShowModalBloqueo: EventEmitter<void> = new EventEmitter<void>();
  @Output() onBuscaDatosHistorialBloqueo: EventEmitter<void> = new EventEmitter<void>();
  @Output() onRutExiste: EventEmitter<void> = new EventEmitter<void>();
  @Output() onNombreChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() onOpenModalEdit: EventEmitter<void> = new EventEmitter<void>();

  @Input() optionsCanal: Array<any> = [];
  @Input() optionsTipoCliente: Array<any> = [];
  @Input() mode: 'ADD' | 'EDIT';
  @Input() bandEdit: '1' | '2';

  listaTipoClienteFilter: Array<any> = [];

  private client: GraphQLClient = null;

  // Forms
  public formEditaDatosPersonales: FormGroup;

  // Data & Tmp
  public rutEmpresa: number;
  public sucursalEmpresa: number;
  public codigoModulo: number;
  public rutUsuario: number;
  public esProveedor: number = 0;

  // Is null when is disabled in Form. That's the reason to separate it
  private rutCliente: string;

  // Utils
  private log: any;

  public itemCliente: cliente_proveedor;
  rutEnviar: any = null;
  bandera: string = '1';
  constructor(
    client: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    public validadores: ValidadoresService,
    public rutService: RutService,
    public toastService: ToastService,
    private messageRendererService: MessageRendererService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clienteProveedorService: ClienteProveedorService,
    private element: ElementRef
  ) {
    this.log = this.clog.log('MANTENEDOR-CLIENTES/ FORM DATOS PERSONALES');
    this.client = client;
  }

  ngOnInit() {
    this.log('ngOnInit');
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
    this.codigoModulo = 1;
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario());
    switch (this.mode) {
      case 'ADD':
        this.createForm();
        this.formEditaDatosPersonales.get('rutCliente').setValue('');
        this.formEditaDatosPersonales.get('canal').valueChanges.subscribe((x: any) => this.filtrarTipoCliente(x));
        this.formAgregaDatosPersonalesChangesSubscriptions();

        // this.formEditaDatosPersonales.get('estadoCliente').disable()
        this.formEditaDatosPersonales.get('estadoCliente').enable();
        this.formEditaDatosPersonales.get('estadoCliente').setValue(true);
        break;
      case 'EDIT':
        this.createForm();
        this.formEditaDatosPersonales.get('');
        this.formEditaDatosPersonales.get('rutCliente').disable();
        this.formEditaDatosPersonales.get('estadoCliente').enable();
        break;
      default:
        break;
    }

    switch (this.bandEdit) {
      case '1':
        this.bandera = '1';
        break;

      case '2':
        this.bandera = '2';
        break;
    }
  }

  createForm() {
    this.log('createForm', this.mode);
    this.formEditaDatosPersonales = new FormGroup({
      rutCliente: new FormControl(
        { value: '' },
        [Validators.minLength(7), Validators.maxLength(13), Validators.required, this.validadores.ValidaFormatoRut]
        // this.validaExistenciaUsuario
      ),
      nombreCliente: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(100)]),
      canal: new FormControl('', [Validators.required]),
      tipoCliente: new FormControl('', [Validators.required]),
      estadoCliente: new FormControl({ value: true, disabled: false }),
      esClienteBloqueado: new FormControl(false),
      rutEmpresa: new FormControl(''),
      datosCliente: new FormControl(''),
    });
  }

  formAgregaDatosPersonalesChangesSubscriptions() {
    this.formEditaDatosPersonales.get('nombreCliente').valueChanges.subscribe((nombre: string) => {
      this.onNombreChange.emit(nombre);
    });

    if (this.bandEdit === '1') {
      this.formEditaDatosPersonales
        .get('rutCliente')
        .valueChanges.pipe(filter(Boolean), debounceTime(1000))
        .subscribe((rutCliente: string) => {
          const rut = this.rutService.QuitarDV(rutCliente);
          this.clienteProveedorService.esProveedor(
            {
              rutCliente: rut,
              rutEmpresa: this.rutEmpresa,
            },
            ({ respuesta }) => {
              this.esProveedor = respuesta;
              const rutClienteFormateado = this.validadores._enmascaraRut(rut.toString());

              switch (this.esProveedor) {
                case 1:
                  //* Existe como cliente
                  this.toastService.error(`El rut ${rutClienteFormateado} ya existe`, 'Atención');
                  this.onRutExiste.emit();
                  this.setFocusOnRut();
                  break;
                case 2:
                  //* Existe como proveedor (Editar)
                  // this.modalEditarProveedor.loadAndShow();
                  Swal.fire({
                    title: `¿Desea agregar el proveedor ${rutClienteFormateado} como cliente?`,
                    showCancelButton: true,
                    confirmButtonText: 'Aceptar',
                    confirmButtonColor: '#2bbbad',
                    cancelButtonText: 'Cancelar',
                    cancelButtonColor: '#A1A1A1',
                  }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                      //TODO: SE ABRIRA MODAL DE EDICION
                      this.rutEnviar = rut;
                      this.onOpenModalEdit.emit(this.rutEnviar);
                      this.bandera = '2';
                    } else {
                      this.formEditaDatosPersonales.get('rutCliente').setValue('');
                      this.formEditaDatosPersonales.get('rutCliente').markAsPristine(); // Marcar como no modificado
                      this.formEditaDatosPersonales.get('rutCliente').markAsUntouched(); // Marcar como no tocado
                    }
                  });
                  break;
                case 3:
                  //* Existe como cliente y proveedor

                  this.toastService.error(`El rut ${rutClienteFormateado} ya existe`, 'Atención');
                  this.onRutExiste.emit();
                  this.setFocusOnRut();
                  break;
                case -1:
                  //* No existe como cliente y proveedor
                  this.toastService.error(`El rut ${rutClienteFormateado}, Error 404`, 'Atención');
                  this.onRutExiste.emit();
                  this.setFocusOnRut();
                  break;
              }
            }
          );
        });
    }
  }

  filtrarTipoCliente(canal: any) {
    console.log({ canal });
    if (!canal) return;
    this.listaTipoClienteFilter = this.optionsTipoCliente.filter((x: any) => x.idcanal === canal).map((x) => ({ value: x.codigo, label: x.descripcion }));
    console.log(this.listaTipoClienteFilter, this.optionsTipoCliente);
  }

  setFocusOnRut() {
    const invalidControl = this.element.nativeElement.querySelector('[formcontrolname="' + 'rutCliente' + '"]');
    this.formEditaDatosPersonales.get('rutCliente').setValue(null);
    invalidControl.focus();
  }

  SearchUser(rutProveedor: number, callback: Function) {
    const self = this;

    this.client.query(
      {
        query: gql`
          query ($rutEmpresa: Decimal, $rutClienteProveedor: Decimal) {
            cliente_proveedor {
              obtenerClienteProveedorDireccion(rutEmpresa: $rutEmpresa, rutClienteProveedor: $rutClienteProveedor) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  rut
                  nombre
                  razon_social
                  mail_intercambio
                  mail_pdf
                  mail_contacto
                  afecto_reglas_comerciales
                  es_cliente
                  es_proveedor
                  telefono_principal
                  telefono_secundario
                  activo
                  fax
                  observaciones
                  descuento_maximo
                  tipo_cliente_codigo
                  tipo_cobro_codigo
                  lista_precio_codigo
                  rut_usuario_creacion
                  rut_usuario_actualiza
                  fecha_actualizacion
                  fecha_registro
                  empresa_rut
                  bloqueado
                  limite_credito
                  giro
                  es_deuda
                  codigo_direccion
                  direccion_completa
                  comuna_codigo
                  es_principal
                  territorio_codigo
                  ruta_codigo
                  fecha_creacion_direccion
                  nombredireccion
                  nombre_contacto
                  codigo_direccion_despacho
                  localidad
                  fono_fijo
                  fono_movil
                  email_contacto
                  latitud
                  longitud
                  referencias
                  facturar_a_casa_matriz
                  direccionactiva
                  condicion_pago_codigo
                  nombrecomuna
                  nombreprovincia
                  nombreregion
                  descripcion_tipo_cliente
                  nombre_usuario_creacion
                  nombre_usuario_actualiza
                  descripcion_ruta
                  descripcion_condicion_pago
                }
              }
            }
          }
        `,
        variables: {
          rutEmpresa: self.rutEmpresa,
          rutClienteProveedor: rutProveedor,
        },
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.cliente_proveedor.obtenerClienteProveedorDireccion;
        callback({ mensajes, respuesta });

        const ok = respuesta !== null;
        if (!ok) {
          this.messageRendererService.showErrors(mensajes);
          return;
        }

        self.formEditaDatosPersonales.get('rutCliente').setValue(self.validadores._enmascaraRut(String(respuesta.rut)));

        self.formEditaDatosPersonales.get('nombreCliente').setValue(respuesta.nombre);
      }
    );
  }

  loadAndShow(cliente: cliente_proveedor, onDatosCargados?: () => void) {
    this.log('loadAndShow. mode', this.mode);
    const self = this;
    const tipoCliente = self.optionsTipoCliente.find((x: any) => x.codigo === cliente.tipo_cliente_codigo);
    this.itemCliente = _.cloneDeep(cliente);

    if (!tipoCliente) {
      self.toastService.error('No se pudo resolver el tipo de cliente.');
      return;
    }

    this.listaTipoClienteFilter = this.optionsTipoCliente.filter((x: any) => x.idcanal === tipoCliente.idcanal).map((x) => ({ value: x.codigo, label: x.descripcion }));

    this.log('loadAndShow', this.itemCliente);

    self.formEditaDatosPersonales.reset();
    self.formEditaDatosPersonales.get('estadoCliente').setValue(self.itemCliente.activo);
    self.formEditaDatosPersonales.get('esClienteBloqueado').setValue(self.itemCliente.bloqueado);
    self.formEditaDatosPersonales.get('rutCliente').setValue(self.validadores._enmascaraRut(String(self.itemCliente.rut)));
    self.rutCliente = self.validadores._enmascaraRut(String(self.itemCliente.rut));
    self.formEditaDatosPersonales.get('nombreCliente').setValue(self.itemCliente.razon_social);
    self.formEditaDatosPersonales.get('canal').setValue(tipoCliente.idcanal);
    self.formEditaDatosPersonales.get('canal').valueChanges.subscribe((x: any) => self.filtrarTipoCliente(x));
    self.formEditaDatosPersonales.get('tipoCliente').setValue(tipoCliente.codigo);
    self.formEditaDatosPersonales.get('datosCliente').setValue(self.itemCliente);
    self.log('formEditaDatosPersonales', self.formEditaDatosPersonales.value);
    if (self.mode === 'EDIT') {
      self.formEditaDatosPersonales.get('rutCliente').disable();
    }
    if (onDatosCargados) {
      onDatosCargados();
    }
  }

  setModoSoloLectura(soloLectura: boolean) {
    if (soloLectura) {
      this.formEditaDatosPersonales.disable();
    } else {
      this.formEditaDatosPersonales.enable();
      if (this.mode === 'EDIT') {
        this.formEditaDatosPersonales.get('rutCliente').disable();
      }
    }
  }

  showModalBloqueo() {
    this.onShowModalBloqueo.emit();
  }

  buscaDatosHistorialBloqueo() {
    this.onBuscaDatosHistorialBloqueo.emit();
  }

  setClienteBloqueado(bloqueo) {
    this.formEditaDatosPersonales.get('esClienteBloqueado').setValue(bloqueo);
  }

  validate() {
    this.formValidatorsService.validateAllFormFields(this.formEditaDatosPersonales);
    return this.formEditaDatosPersonales.valid;
  }

  getFormData() {
    if (this.mode === 'ADD') {
      const currentEstadoClienteState = this.formEditaDatosPersonales.get('estadoCliente').enabled;
      this.formEditaDatosPersonales.get('estadoCliente').enable();
      const formValue = this.formEditaDatosPersonales.value;
      currentEstadoClienteState ? this.formEditaDatosPersonales.get('estadoCliente').enable() : this.formEditaDatosPersonales.get('estadoCliente').disable();
      return _.cloneDeep(formValue);
    }
    return { ...this.formEditaDatosPersonales.getRawValue(), rutCliente: this.rutCliente };
  }

  getRutCliente() {
    if (this.mode === 'ADD') return this.formEditaDatosPersonales.get('rutCliente').value;
    return this.rutCliente;
  }

  reset() {
    this.formValidatorsService.reset(this.formEditaDatosPersonales);
  }

  public setAddDefaults() {
    this.formEditaDatosPersonales.get('estadoCliente').setValue(true);
    this.formEditaDatosPersonales.get('esClienteBloqueado').setValue(false);
  }
}
